import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c388058"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mxa-nologin-title",
  "data-test": "title_product"
}
const _hoisted_2 = {
  key: 0,
  class: "mxa-nologin-title",
  "data-test": "title_name"
}
const _hoisted_3 = {
  key: 1,
  class: "mxa-nologin-title",
  "data-test": "title_name"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NologinTitle',
  props: {
  // タイトル項目
  title: {
    type: String,
    default: '',
  },
  // パスワード設定画面かどうか
  isEntry: {
    type: Boolean,
    default: false,
  },
  // 登録種別
  type: {
    type: String,
    default: '0',
  },
},
  setup(__props) {

const props = __props

// プロパティ定義

// パスワード設定関連のタイトルメッセージキー
const getTitleKey = () => (props.type === '0' ? 'body.common.title.entry' : 'body.common.title.reset')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('body.common.product.name')), 1),
    (props.isEntry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(getTitleKey())), 1))
      : _createCommentVNode("", true),
    (!props.isEntry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.title), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})